import React, { Component } from "react";
import axios from "axios";
import * as d3 from "d3";
import LoadingIcon from "./icons/LoadingIcon";
import TwoModelsGridExtended from "./TwoModelsGridExtended";
import DataSetBlock from "./blocks/DatasetBlock";

class Main extends Component {
    constructor(props) {
        super(props);
        this.state = {
            domain: this.props.domain,
            current_page: 0,
            num_examples_per_page: 20,
            option_id: 0,
            selected_ids: null,
            models: [],
            current_passages: [],
            searching: false,
            allPassages: [],
            dataset: null,
            show_loading: true,
            selected_metric: "AER",
            selected_language: "src",
            selected_model: null,
            search_term: null,
            model1: null,
            model2: null,
            translation_pairs:[],
            pie_chart_color: {"correct": "#65a30d", "missing": "#ea8034", "wrong": "#dc2626"},
            scatter_plot_selected_setting: "src_length",
            settings : {
                "src_length": {"attr": "src_length", "label": "Source Sentence Length"},
                "tgt_length": {"attr": "tgt_length",  "label": "Target Sentence Length"},
                "sentence_id": {"attr": "id",  "label": "Sentence ID"}
            },
            sub_precision: null,
            sub_recall: null,
            sub_f1:null,
            sub_aer: null,
            side_diagram: "pie",
            side_diagram_cls: "w",
            show_translation_pairs_loading: false,
        }
    }

    setModel2 = (event) =>{
        // console.log(event.target.value=="-1", event.target.value==-1)
        this.setState({
            model2: event.target.value==="-1"?null:event.target.value
        }, ()=>{
            //  event.target.value=="-1"?this.drawScatterPlot2():this.drawVennDiagram()
        })
    }

    model_A_outperforms_model_B = (model_A, model_B) =>{
        const {current_passages, allPassages, selected_metric} = this.state
        let temp = allPassages.filter(a => a[model_A]["stat"][selected_metric] > a[model_B]["stat"][selected_metric] )
        this.setState({
            current_passages: temp
        })
    }
    model_A_equals_model_B = (model_A, model_B) =>{
        const {allPassages, selected_metric} = this.state
        let temp = allPassages.filter(a => a[model_A]["stat"][selected_metric] === a[model_B]["stat"][selected_metric] )
        this.setState({
            current_passages: temp
        })
    }

    sortSentences = (descending)=>{
        const {selected_metric, model1, current_passages} = this.state
        if(model1!==null){
            current_passages.sort(function(a, b){
                return a[model1]["stat"][selected_metric] - b[model1]["stat"][selected_metric]
            })
            if(descending){
                current_passages.reverse()
            }
            this.setState({
                current_passages: current_passages
            })
        }
    }

    componentDidMount() {
        const {domain} = this.state;
        const query = new URLSearchParams(window.location.search);
        const dataset_id = query.get('ds');
        var url = domain+"api/getModelsByDatasetID?ds_id="+dataset_id
        axios.get(url)
            .then(res => {
                this.setState({
                    models:res.data.models,
                    show_loading: false,
                    models_colors: this.getColors(),
                    dataset: res.data.dataset,
                    current_passages: res.data.gs_sentences,
                    allPassages: res.data.gs_sentences
                },()=>{this.drawBarChart();
                    let model_id = query.get('m');
                    if(model_id!==null && model_id!==undefined){

                        this.setSelectedModel(parseInt(model_id))
                    }
                });
            });

    }

// Drawing Charts
    drawBarChart = ()=>{
        const {models, selected_metric } = this.state
        const models_colors = this.getColors() //models_colors===null?:models_colors
        const max_tp_length = Math.max(...models.map((model, i)=>{ return model.stat.tp})) *1.05

        const max_value = {"AER": 1, "precision": 1, "recall": 1, "f1": 1,
            "pac": 1, "coverage": 1, "tp": max_tp_length}

        let margin = {top: 10, right: 20, bottom: 130, left: 40};
        let svgWidth = 500, svgHeight = 400;
        let height = svgHeight- margin.top- margin.bottom, width = svgWidth - margin.left - margin.right;

        let x = d3.scaleBand().rangeRound([0, width]).padding(0.2),
            y = d3.scaleLinear().rangeRound([height, 0]);


        x.domain(models);
        y.domain([0, max_value[selected_metric]]); // d3.max(sourceCount, function(d) { return d/300; })]

        let tooltip = d3.select("#tooltip_main_barchart").append("div")
            .attr("class", "tooltip_navigation")
            .style("opacity", 0);

        // append the svg object to the body of the page
        d3.select("#barChart_main").select("svg").remove();
        var svg = d3.select("#barChart_main")
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .style("display", "block")
            .style("margin", "auto")
            .append("g")
            .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")");

        let parent = this;

        var xis = svg.append("g")
            .attr("class", "axis axis--x")
            .attr("transform", "translate(0," + (height ) + ")")
            .call(d3.axisBottom(x).ticks(models.length)
            .tickFormat((d, i) => {return d.title}));
        if(models.length > 4){
            xis.selectAll("text")
                .style("text-anchor", "end")
                .attr("dx", "-.8em")
                .attr("dy", ".15em")
                .attr("transform", "rotate(-65)");
        }


        svg.append("g")
            .attr("class", "axis axis--y")
            .attr("id", "axis_y")
            //.attr("transform", "translate(-5, 0)")
            .call(d3.axisLeft(y).ticks(5))

        d3.select("#axis_y")
            .append("text")
            .attr("transform", "rotate(-90) translate(-80, -30)")
            .style("fill", "#333")
            .text(selected_metric.toUpperCase());

        // Create rectangles

        let bars = svg.selectAll('.bar')
            .data(models)
            .enter()
            .append("g");

        bars.append('rect')
            .attr('class', 'bar')
            .attr("x", function(d) { return x(d); })
            .attr("y", function(d) {return y(d.stat[selected_metric]); })
            .attr("id", function(d) { return "mainBarChart_" +d.model_id; })
            .attr("fill", function(d){return models_colors[d.title] })
            //.style("stroke", "black").style("stroke-width", (d)=>{return model1===d?2:0})
            .attr("width", x.bandwidth())
            .attr("height", function(d) { return height - y(d.stat[selected_metric]); })
            .on("click", (d, a)=>{parent.setSelectedModel(a.model_id)})
            .on("mouseover", function(s, d) {
                tooltip.html("<span class='uppercase'>"+ d.title +"</span><br>"+
                    " <b class='uppercase'>  "+selected_metric+ "  <span class='ml-2 text-lg' >"+ d.stat[selected_metric]+ "</span></b>"
                )
                    .style("left", s.x + "px")
                    .style("top", (s.pageY - 28) + "px")
                    .style("background-color", "rgb(64, 64, 64)")
                    .style("color", "#FFFFFF").style("opacity", .95);
                // highlight the model and the metric
                // d3.selectAll("[metric='"+mod+ "']").attr("fill", labels_highlight_color).attr("font-weight", "bold");
                // d3.selectAll("[model='"+value['model']+ "']").attr("fill", labels_highlight_color).attr("font-weight", "bold");
            })
            .on("mouseout", function(s) {
                tooltip.html("").style("opacity", 0);
                // d3.selectAll("[metric='"+mod+ "']").attr("fill", labels_color).attr("font-weight", "");
                // d3.selectAll("[model='"+value['model']+ "']").attr("fill", labels_color).attr("font-weight", "");
                // d3.selectAll("[model='"+value['model']+ "']").each(function (p, j) {
                //     const model_name = this.getAttribute("model")
                //     const highlight = selected_models.includes(model_name)
                //     d3.select(this).attr("fill", getLabelColor(highlight, model_name))
                // })
            });

        // bars.append("text")
        //     .text(function(d) {
        //         return d.stat[selected_metric];
        //     })
        //     .attr("x", function(d){
        //         return x(d) + x.bandwidth()/2;
        //     })
        //     .attr("y", function(d){
        //         return  y(d.stat[selected_metric]) - 5;
        //     })
        //     .attr("font-family" , "sans-serif")
        //     .attr("font-size" , "10px")
        //     .attr("fill" , "black")
        //     .attr("text-anchor", "middle");
    }

    drawScatterPlot = ()=>{
        if(this.state.side_diagram==="scatter"){
            const {allPassages, model1, settings, scatter_plot_selected_setting,
                selected_metric, selected_ids} = this.state
            const models_colors = this.getColors()
            const max_src_length = Math.max.apply(Math, allPassages.map(function(o) { return o.src_length; }))
            const max_tgt_length = Math.max.apply(Math, allPassages.map(function(o) { return o.tgt_length; }))

            const selected_setting = scatter_plot_selected_setting

            const max_value = {
                "src_length": max_src_length,
                "tgt_length": max_tgt_length,
                "sentence_id": allPassages.length
            }

            const max_value_y = {"AER": 1, "precision": 1, "recall": 1, "f1": 1, "tp": 55}


            if(model1!==null){
                const parent = this;
                let divWidth = d3.select("#scatter_plot").node().getBoundingClientRect().width
                let margin = {top: 10, right: 20, bottom: 30, left: 60},
                    width = 600 - margin.left - margin.right,
                    height = 300 - margin.top - margin.bottom;

                // append the svg object to the body of the page
                d3.select("#scatter_plot").select("svg").remove();
                var svg = d3.select("#scatter_plot")
                    .append("svg")
                    .attr("width", width + margin.left + margin.right)
                    .attr("height", height + margin.top + margin.bottom)
                    .append("g")
                    .attr("transform",
                        "translate(" + margin.left + "," + margin.top + ")");

                // Add X axis
                var x = d3.scaleLinear()
                    .domain([0, max_value[selected_setting]]) // allPassages.length
                    .range([ 0, width ]);
                svg.append("g")
                    .attr("id", "scatterplot_axis_x")
                    .attr("transform", "translate(0," + height + ")")
                    .call(d3.axisBottom(x));

                d3.select("#scatterplot_axis_x")
                    .append("text")
                    .attr("transform", "translate("+(width*0.48)+", 25)").attr("fill", "#333")
                    .text(settings[selected_setting]["label"]);

                // Add Y axis
                var y = d3.scaleLinear()
                    .domain([0, max_value_y[selected_metric]])
                    .range([ height, 0]);
                svg.append("g").attr("id", "scatterplot_axis_y")
                    .call(d3.axisLeft(y));

                d3.select("#scatterplot_axis_y")
                    .append("text")
                    .attr("transform", "rotate(-90) translate(-"+height/2+", -30)").attr("fill", "#333")
                    .text(selected_metric.toUpperCase());
                // Add dots
                var circles = svg.append('g')
                    .selectAll("dot")
                    .data(allPassages)
                    .enter()
                    .append("circle")
                    .attr("idx", (d)=>{return d.id})
                    .attr("cx", function (d) { return x(d[settings[selected_setting]["attr"]]); } ) // x(d.id)
                    .attr("cy", function (d) { return y(d[model1]["stat"][selected_metric]); } )
                    .attr("r", 3)
                    .attr("opacity", "0.66")
                    .attr("stroke-width", (d)=>{return (selected_ids!==null && selected_ids.includes(d.id))?1:0})
                    .attr("stroke", '#000')
                    .style("fill", models_colors[model1])
                    .on("click", function(d, a){parent.set_selected_id(a.id)})

                let highlightBrushedCircles = (d)=> {

                    if (d.selection != null) {

                        // revert circles to initial style
                        circles.attr("class", "non_brushed");

                        var brush_coords = d.selection // d3.brushSelection(d);
                        // style brushed circles
                        if(brush_coords!==null){
                            circles.filter(function (){

                                var cx = d3.select(this).attr("cx"),
                                    cy = d3.select(this).attr("cy");

                                return isBrushed(brush_coords, cx, cy);
                            })
                                .attr("class", "brushed");
                        }
                    }
                }

                let isBrushed = (brush_coords, cx, cy)=> {

                    var x0 = brush_coords[0][0],
                        x1 = brush_coords[1][0],
                        y0 = brush_coords[0][1],
                        y1 = brush_coords[1][1];

                    return x0 <= cx && cx <= x1 && y0 <= cy && cy <= y1;
                }

                let brush = d3.brush()
                    .on("brush", (d)=>{highlightBrushedCircles(d)})
                    .on("end", (d)=>{setBrushSelection(d)});

                svg.append("g").attr("id", "brush_area")
                    .call(brush);

                let setBrushSelection = (d)=> {
                    // disregard brushes w/o selections
                    // ref: http://bl.ocks.org/mbostock/6232537
                    if (!d.selection) return;
                    // console.log(brush, d.target)
                    // programmed clearing of brush after mouse-up
                    // ref: https://github.com/d3/d3-brush/issues/10
                    d3.select("#brush_area").call(brush.move, null);

                    var d_brushed =  d3.selectAll(".brushed").data();

                    let selected_ids = null
                    if (d_brushed.length > 0) {
                        selected_ids = d_brushed.map(d => {return d.id})
                    }
                    this.setSelectedIds(selected_ids)
                }
            }
        }

    }

    drawPieChart = ()=>{
        const {selected_model, models, pie_chart_color} = this.state
        if(selected_model!== null && this.state.side_diagram==="pie"){
            let divWidth = d3.select("#pie_chart").node().getBoundingClientRect().width
            let divHeight= d3.select("#pie_chart").node().getBoundingClientRect().height
            let smodel = models.filter((m)=>{ return m.model_id===selected_model})[0]
            let margin = {top: 5, right: 10, bottom: 5, left: 20};
            let svgWidth = divWidth, svgHeight = 300;
            let height = svgHeight- margin.top- margin.bottom, width = svgWidth - margin.left - margin.right;

            var radius = Math.min(width, height) / 2 - 15

            d3.select("#pie_chart").select("svg").remove();
            var svg = d3.select("#pie_chart")
                .append("svg")
                .attr("width", width)
                .attr("height", height)
                .style("display", "block")
                .style("margin", "auto")
                .append("g")
                .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

            // Create the data
            var data = [{"key":"missing", "value": (smodel.stat.missing_pairs)},
                {"key":"correct", "value": smodel.stat.A_P_intersections},
                {"key":"wrong", "value": (smodel.stat.tp-smodel.stat.A_P_intersections)}]

            // Compute the position of each group on the pie:
            var pie = d3.pie().sort(null)
                .value(function(d) {return d.value; })
            var data_ready = pie(data)
            var arc = d3.arc()
                .innerRadius(radius * 0.45)         // This is the size of the donut hole
                .outerRadius(radius * 0.8)

            var outerArc = d3.arc()
                .innerRadius(radius * 0.85)
                .outerRadius(radius * 0.85)

            // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
             svg.selectAll('whatever')
                .data(data_ready)
                .enter()
                .append('path')
                .attr('d',arc)
                .attr('fill', function(d){ return(pie_chart_color[d.data.key]) })
                .attr("stroke", "white")
                .style("stroke-width", "4px")
                .style("opacity", 0.8)
                .on("click", (e, d)=>{this.pieChartClicked(d)})

            svg
                .selectAll('allPolylines')
                .data(data_ready)
                .enter()
                .append('polyline')
                .attr("stroke", function(d){ return(pie_chart_color[d.data.key]) })
                .style("fill", "none")
                .attr("stroke-width", 1)
                .attr('points', function(d) {
                    var posA = arc.centroid(d) // line insertion in the slice
                    var posB = outerArc.centroid(d) // line break: we use the other arc generator that has been built only for that
                    var posC = outerArc.centroid(d); // Label position = almost the same as posB
                    var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2 // we need the angle to see if the X position will be at the extreme right or extreme left
                    posC[0] = radius * 0.75 * (midangle < Math.PI ? 1 : -1); // multiply by 1 or -1 to put it on the right or on the left
                    return [posA, posB, posC]
                })

            svg
                .selectAll('allLabels')
                .data(data_ready)
                .enter()
                .append('text')
                .style('fill', function(d){ return(pie_chart_color[d.data.key]) })
                .text( function(d) {  return d.data.value } )
                .attr('transform', function(d) {
                    var pos = outerArc.centroid(d);
                    var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2
                    pos[0] = radius * 0.8 * (midangle < Math.PI ? 1 : -1);
                    return 'translate(' + pos + ')';
                })
                .style('text-anchor', function(d) {
                    var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2
                    return (midangle < Math.PI ? 'start' : 'end')
                })

        }
    }

// Handle Events

    setSelectedLanguage = (e) =>(
        this.setState({
            selected_language:e
        })
    )

    setSelectedModel = (x)=>{
        this.setState({
                selected_model:x,
                model1: this.state.models.filter(m=>{return m.model_id===x})[0].title,
                translation_pairs: []
            },()=>{
                this.styleSelectedBarchartBar();
                this.drawPieChart();
                this.drawScatterPlot();
                this.calculateMetrics();
            }
        )
    }

    setSelectedIds = (ids) => {
        let temp = this.state.allPassages;
        if(ids!==null){
            temp = this.state.allPassages.filter(p=> ids.includes(p.id))
        }
        this.setState({
            selected_ids:ids,
            current_passages: temp,
            current_page:0
        }, ()=>{this.calculateMetrics(); this.drawScatterPlot()})
    }

    calculateMetrics(){
        const { current_passages, selected_model, models} = this.state
        if(selected_model!==null){
            let S = 0, P = 0, A = 0, AP = 0, AS = 0;
            for(let passage of current_passages){
                let model_title = models.filter(m=>{return m.model_id===selected_model})[0].title;
                let model = passage[model_title]
                // console.log(selected_model, model)
                P += passage.gs.length;
                S += passage.gs.filter(s =>{return s[2]==="s"}).length
                A += model.stat.tp
                AP += model.stat.A_P_intersections
                AS += model.stat.A_S_intersections
            }
            // console.log(P, S, A, AP, AS)
            let pre =AP/A, rec = AS/S;
            this.setState({
                sub_precision: pre.toFixed(4),
                sub_recall: rec.toFixed(4),
                sub_f1:(2*pre*rec/(pre+rec)).toFixed(4),
                sub_aer: (1 - ((AP+AS)/(A+S))).toFixed(4)
            })
        }


    }

    pieChartClicked = (d)=>{
        const {domain, dataset, selected_model, selected_language} = this.state

        let model = selected_model===null?'':selected_model
        console.log(d)
        if(d.data.key==="wrong" || d.data.key==="missing"){
            this.setState({
                show_translation_pairs_loading: true,
                translation_pairs:[]
            });
            var url = domain+"api/wrongPairs?ds_id="+dataset.id+"&m="+encodeURI(model)+"&cls="+ (d.data.key==="wrong"?"w":"m")
            console.log(url)
            axios.get(url)
                .then(res => {
                    this.setState({
                        translation_pairs:res.data.pairs,
                        show_translation_pairs_loading: false,
                        side_diagram_cls: d.data.key
                    },()=>{
                    });
                });
        }


    }

    keyboardClicked = (e)=> {
        if(e.key === 'Enter')
            this.search()
    }

    search = () => {
        let q = document.getElementById("searchfield").value;
        this.setState({
            searching: true,

        });
        const {domain, dataset, selected_model, selected_language} = this.state

        let model = selected_model===null?'':selected_model
        var url = domain+"api/searchGsSentences?ds_id="+dataset.id+"&q="+encodeURI(q)+"&c="+encodeURI(selected_language)+"&m="+encodeURI(model)
        console.log(url)
        axios.get(url)
            .then(res => {
                this.setState({
                    search_term: q,
                    current_passages: res.data.gs_sentences,
                    allPassages: res.data.gs_sentences,
                    searching: false,
                }, ()=>{this.calculateMetrics()});
            });
    }

    loadWrongPairs = (x) => {

        this.setState({
            searching: true,

        });
        const {domain, dataset, selected_model} = this.state

        let model = selected_model===null?'':selected_model
        var url = domain+"api/findPair?ds_id="+dataset.id+"&src="+encodeURI(x.src)+"&tgt="+encodeURI(x.tgt)+"&m="+encodeURI(model)+"&cls="+x.cls
        console.log(url)
        axios.get(url)
            .then(res => {
                this.setState({
                    current_passages: res.data.gs_sentences,
                    allPassages: res.data.gs_sentences,
                    searching: false,
                }, ()=>{this.calculateMetrics()});
            });
    }

    getColors = ()=>{
        let keys = []
        for(let model of this.state.models){
            keys.push(model.title)
        }
        var getColor = d3.scaleOrdinal().domain(keys)
            .range(['#4e79a7', '#f28e2c', '#e15759', '#76b7b2', '#af7aa1', '#ff9da7', '#9c755f', '#bab0ab', '#edc949'])
        let models_colors = {};
        for(let model of this.state.models){
            let key = model.title;
            models_colors[key] = getColor(key)
        }
        return models_colors
    }

    changeSelectedMetric = (metric) =>{
        this.setState({
            selected_metric: metric
        }, ()=>{
            this.drawBarChart();
            this.styleSelectedBarchartBar();
            this.drawScatterPlot()
        })
    }

    styleSelectedBarchartBar = ()=>{
        d3.selectAll("[id^='mainBarChart_']").attr("stroke-width", 0).attr("stroke", "black");
        d3.select("#mainBarChart_"+this.state.selected_model).attr("stroke-width", 2).attr("stroke", "black");
    }

    setCurrentPageId = (id)=>{
        this.setState({
            current_page: id
        })
    }

    setSideDiagram = (x)=>{
        this.setState({
            side_diagram:x
        }, ()=>{x==="pie"? this.drawPieChart():this.drawScatterPlot()})
    }

    setScatterPlotSelectedSetting=(option)=>{
        this.setState({
            scatter_plot_selected_setting: option
        }, ()=>{this.drawScatterPlot()})
    }

    resetScatterPlotSetting =()=>{
        this.setState({
            selected_ids:[],
            current_passages: this.state.allPassages,
            current_page:0
        }, ()=>{this.calculateMetrics(); this.drawScatterPlot()})
    }


    render() {
        const {models, dataset, current_page, num_examples_per_page, show_loading, current_passages, side_diagram,
            selected_model, selected_metric, pie_chart_color, allPassages, search_term, selected_language,model1,model2,
            scatter_plot_selected_setting, settings} = this.state

        const start_id = current_page*num_examples_per_page
        const end_id = Math.min(start_id+num_examples_per_page, allPassages.length)

        let selected_metric_css = "px-2 py-1 bg-neutral-700 rounded text-xs text-white m-1 hover:bg-gray-800"
        let default_metric_css = "px-2 py-1 border border-gray-300 rounded text-xs text-gray-600 m-1  hover:bg-gray-200"
        var num_of_pages = Math.ceil(current_passages.length/num_examples_per_page)
        // let modelTitle = selected_model!==null?models.filter(m=>{return m.id===selected_model})[0].title:""

        return (
            <div>
                {show_loading?
                    <div className="flex m-auto justify-center"><LoadingIcon /></div>:

                    <div>
                        <DataSetBlock dataset={dataset}/>

                        <div>
                            <div className="border bg-white border-gray-200 mb-5 p-3 rounded-lg shadow-lg">
                               <div className="m-auto flex">
                                    <div className="md:w-full lg:w-1/2">
                                        <div className="text-xs text-left">Select a model:</div>
                                        <div>
                                            <button className={selected_metric==="AER"?selected_metric_css:default_metric_css}
                                                    onClick={()=>{this.changeSelectedMetric("AER")}}>AER</button>
                                            <button className={selected_metric==="precision"?selected_metric_css:default_metric_css}
                                                    onClick={()=>{this.changeSelectedMetric("precision")}}>Precision</button>
                                            <button className={selected_metric==="recall"?selected_metric_css:default_metric_css}
                                                    onClick={()=>{this.changeSelectedMetric("recall")}}>Recall</button>
                                            <button className={selected_metric==="f1"?selected_metric_css:default_metric_css}
                                                    onClick={()=>{this.changeSelectedMetric("f1")}}>F1</button>
                                            <button className={selected_metric==="tp"?selected_metric_css:default_metric_css}
                                                    onClick={()=>{this.changeSelectedMetric("tp")}}># Translation Pairs</button>
                                            <button className={selected_metric==="coverage"?selected_metric_css:default_metric_css}
                                                    onClick={()=>{this.changeSelectedMetric("coverage")}}>Coverage</button>
                                            <button className={selected_metric==="pac"?selected_metric_css:default_metric_css}
                                                    onClick={()=>{this.changeSelectedMetric("pac")}}>PAC</button>
                                        </div>
                                        {/*<RangeSlider />*/}
                                        <div  id="barChart_main">

                                        </div>
                                        <div className="mt-5">
                                            {/*{models.map(model=>{*/}
                                            {/*    return <span className="m-2 px-2 py-1 border border-gray-300 rounded text-xs " key={"model_toggle_button_"+model}>{model}</span>*/}
                                            {/*})}*/}

                                        </div>
                                    </div>
                                    <div className="md:w-full lg:w-1/2 ">
                                        {selected_model!==null?<div className="flex mt-5">
                                            <button onClick={()=>{this.setSideDiagram("pie")}} className={(side_diagram==="pie"?"text-white  bg-neutral-700":"text-neutral-700 bg-white") + " border border-neutral-300 px-2 py-1 rounded text-xs m-1 hover:bg-neutral-600 hover:text-yellow-500"}
                                            >Word Level</button>
                                            <button onClick={()=>{this.setSideDiagram("scatter")}} className={(side_diagram==="scatter"?"text-white  bg-neutral-700":"text-neutral-700 bg-white ") + " border border-neutral-300 px-2 py-1 rounded text-xs m-1 hover:bg-neutral-600 hover:text-yellow-500"}>Sentence Level</button>
                                        </div>:null}
                                        {selected_model!==null?side_diagram==="scatter"?
                                        <div>
                                            <div  id="scatter_plot" ></div>
                                            <div className="pt-4 justify-center">
                                                {Object.entries(settings).map((setting)=>{

                                                        let cls= setting[0]===scatter_plot_selected_setting?selected_metric_css:default_metric_css
                                                        return <button className={cls}
                                                                       key={"model_toggle_button_"+setting[1].label}
                                                                       onClick={()=>{this.setScatterPlotSelectedSetting(setting[0])}}>{setting[1].label}</button>
                                                    })}
                                                <button className="px-2 py-1 border border-gray-300 rounded text-xs text-white bg-red-800 m-1  hover:bg-red-600"
                                                        key={"model_toggle_button_reset"}
                                                        onClick={()=>{this.resetScatterPlotSetting()}}>Reset Selection</button>
                                                    <div>
                                                        <span className="text-xs m-1">Compare
                                                               <span className="text-xs px-1 py-1 m-1 rounded text-white"
                                                                     style={{"backgroundColor": this.getColors()[model1]}}> {model1} </span>
                                                                with ..
                                                        </span>
                                                        <select className="form-select form-select-sm mb-3 appearance-none inline-block  px-4 py-1 text-xs font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                                                aria-label=".form-select-lg example"

                                                                onChange={(e)=>{this.setModel2(e)}}>
                                                            <option value={-1} >..</option>
                                                            {models.map(m=>{
                                                                return  m.id!==selected_model? <option value={m.id}>{m.title}</option>:null
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                        </div>:null:null}

                                        {selected_model!==null?side_diagram==="pie"?
                                            <div className="flex">
                                                {/*Pie Chart */}
                                                <div className="w-1/2">
                                                    <span className="mr-2 ml-8 text-xs pt-1">Model's predictions compared to Gold Standad</span>
                                                    <div id="pie_chart">

                                                    </div>
                                                    <div className="flex m-auto justify-center">
                                                    <span className="mr-2 text-xs text-white px-2 rounded py-1"
                                                          style={{backgroundColor: pie_chart_color["correct"]}}>
                                                    Correct</span>
                                                        <span className="mr-2 text-xs text-white px-2 rounded py-1"
                                                              style={{backgroundColor: pie_chart_color["missing"]}}>
                                                    Missig</span>
                                                        <span className="mr-2 text-xs text-white px-2 rounded py-1"
                                                              style={{backgroundColor: pie_chart_color["wrong"]}}>
                                                    Wrong</span>
                                                    </div>
                                                </div>
                                                <div className="w-1/2">

                                                    <div className="text-sm font-bold mb-2">
                                                    {this.state.translation_pairs.length > 0?(
                                                        this.state.side_diagram_cls==="wrong"?<span className="mb-2 mr-2 text-xs text-white px-2 rounded py-1"
                                                                                                     style={{backgroundColor: pie_chart_color["wrong"]}}>
                                                            Wrong Translation Pairs</span>: <span className="mb-2 mr-2 text-xs text-white px-2 rounded py-1"
                                                                                 style={{backgroundColor: pie_chart_color["missing"]}}>
                                                    Missig Translation Pairs</span>
                                                    ):null}
                                                    </div>
                                                    {this.state.show_translation_pairs_loading?
                                                        <LoadingIcon />:null}
                                                    {this.state.translation_pairs.length > 0?
                                                    <div className="overflow-y-scroll rounded border-2 border-neutral-300"
                                                         style={{height:330}}>

                                                        <table>
                                                            <thead></thead>
                                                            {this.state.translation_pairs.map((x, i)=>{
                                                                return(
                                                                    <tr key={"tr_id_"+i} className="border-b text-neutral-600 hover:cursor-pointer hover:bg-red-100"
                                                                        onClick={()=>{this.loadWrongPairs(x)}} >
                                                                        <td className="text-center text-sm">{x.src}</td>
                                                                        <td className="text-center text-sm">{x.tgt}</td>
                                                                        <td className="text-center text-sm">{x.freq}</td>
                                                                    </tr>)
                                                            })}</table>
                                                    </div>:null}

                                                </div>

                                            </div>
                                            :null:null}

                                    </div>
                               </div>
                                {selected_model!==null?
                               <div className="flex m-auto justify-center my-2">
                                   <span className="rounded text-xs  text-white px-2 py-1 mr-1"
                                         style={{"backgroundColor": this.getColors()[models.filter(m=>{return m.model_id===selected_model})[0].title], "fontSize": "11px"}}>
                                       {models.filter(m=>{return m.model_id===selected_model})[0].title}
                                    </span>

                                        <span className={(selected_metric==='AER'?"bg-yellow-600 ":"bg-neutral-600 ") +"  rounded text-xs text-white pl-1 py-1 mr-1"}>AER
                                        <span className="rounded bg-white text-neutral-600 px-1 mx-1">{this.state.sub_aer}</span>
                                    </span>
                                    <span className={(selected_metric==='precision'?"bg-yellow-600 ":"bg-neutral-600 ") +"  rounded text-xs text-white pl-1 py-1 mr-1"}>Precision
                                        <span className="rounded bg-white text-neutral-600 px-1 mx-1">{this.state.sub_precision}</span>
                                    </span>
                                        <span className={(selected_metric==='recall'?"bg-yellow-600 ":"bg-neutral-600 ") +"  rounded text-xs text-white pl-1 py-1 mr-1"}>Recall
                                        <span className="rounded bg-white text-neutral-600 px-1 mx-1">{this.state.sub_recall}</span>
                                    </span>
                                        <span className={(selected_metric==='f1'?"bg-yellow-600 ":"bg-neutral-600 ") +"  rounded text-xs text-white pl-1 py-1 mr-1"}>F1
                                        <span className="rounded bg-white text-neutral-600 px-1 mx-1">{this.state.sub_f1}</span>
                                    </span>
                                </div>:null}
                        </div>

                            {/*Sentences*/}
                            <div className="flex items-center justify-center">
                                <div className="flex border-2 rounded">
                                    <input type="text" id="searchfield" onKeyDown={(e)=>{this.keyboardClicked(e)}}
                                           className="px-4 py-2 w-80" placeholder="Search..." />
                                        <button className="flex items-center justify-center px-4 border-l"
                                         onClick={()=>{this.search()}}>
                                            <svg className="w-6 h-6 text-gray-600" fill="currentColor"
                                                 xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 24 24">
                                                <path
                                                    d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"/>
                                            </svg>
                                        </button>

                                </div>
                                <input type="radio" id="radio_src" value="src"
                                       className="ml-6 mr-1" name="radio_language" checked={selected_language==="src"}
                                       onChange={(e)=>{this.setSelectedLanguage("src")}}/>
                                <span className="text-sm ">{dataset.src_language}</span>
                                <input type="radio" id="radio_tgt" value="tgt" checked={selected_language==="tgt"}
                                       className="ml-6 mr-1" name="radio_language"
                                       onChange={(e)=>{this.setSelectedLanguage("tgt")}}/>
                                <span className="text-sm ">{dataset.tgt_language}</span>
                            </div>
                            {this.state.searching?
                                <div className="flex m-auto justify-center"><LoadingIcon /></div>:
                            <div>
                                {num_of_pages > 1 ?
                                    <div className="mt-5 flex items-center justify-center">{
                                        [...Array(num_of_pages).keys()].map(page_id =>{
                                            var bg_color = current_page===page_id?"bg-yellow-600":"bg-neutral-700 hover:text-yellow-500"
                                            return <span className={bg_color + " mx-1 py-1 text-white px-2 text-xs rounded cursor-pointer"}
                                                         onClick={()=>{this.setCurrentPageId(page_id)}} key={"page_button_"+page_id}>
                                                        {page_id+1}
                                                    </span>
                                        })
                                    }
                                    </div>:null}
                                <div className="px-2 text-xs text-gray-800 mt-3 flex items-center justify-center">Showing sentences {start_id+1} to {Math.min(end_id, current_passages.length)} from {current_passages.length}</div>

                                <div className=" mb-3 grid place-content-end">
                                    {model1!==null?
                                        <div className="">
                                            {model2!==null?
                                                <button className={default_metric_css}
                                                        onClick={()=>{this.model_A_outperforms_model_B(model1, model2)}}>
                                                    <span style={{"color": this.state.models_colors[model1]}}  >{model1} ({selected_metric})</span> > <span style={{"color": this.state.models_colors[model2]}}>{model2} ({selected_metric})</span>
                                                </button>:null}

                                            {model2!==null?
                                                <button className={default_metric_css}
                                                        onClick={()=>{this.model_A_outperforms_model_B(model2, model1)}}>
                                                    <span   style={{"color": this.getColors()[model1]}}>{model1} ({selected_metric})</span> &#60; <span style={{"color": this.getColors()[model2]}}  >{model2} ({selected_metric})</span>
                                                </button>:null}
                                            {model2!==null?
                                                <button className={default_metric_css}
                                                        onClick={()=>{this.model_A_equals_model_B(model2, model1)}}>
                                                    <span   style={{"color": this.getColors()[model1]}}>{model1} ({selected_metric})</span> = <span style={{"color": this.getColors()[model2]}}  >{model2} ({selected_metric})</span>
                                                </button>:null}


                                            <svg xmlns="http://www.w3.org/2000/svg" onClick={()=>{this.sortSentences(true)}}
                                                 title={"Sort passage by according to "+ model1+" by " + selected_metric + " descending"}
                                                 className="h-5 w-5 mx-1 text-gray-500 inline-block hover:text-gray-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <title>{"Sort passage by according to "+ model1+" by " + selected_metric + " descending"}</title>
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" />
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" onClick={()=>{this.sortSentences(false)}}
                                                 title={"Sort passage by according to "+ model1+" by " + selected_metric + " ascending"}
                                                 className="h-5 w-5 mx-1 text-gray-500 inline-block hover:text-gray-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <title>{"Sort passage by according to "+ model1+" by " + selected_metric + " ascending"}</title>
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
                                            </svg>
                                        </div>:null}

                                </div>

                                <div>
                                    {
                                        current_passages.slice(start_id, end_id).map((passage, i) =>{
                                        // console.log(selected_model!==null?passage[model1_name]:null)
                                        return <TwoModelsGridExtended
                                                                    model1={selected_model}
                                                                    model2={null}
                                                                    passage={passage}
                                                                    models={models.map(m=>{return m.title})}
                                                                    selected_metric={selected_metric}
                                                                    colors={this.getColors()}
                                                                    model1_name={model1}
                                                                    model2_name={model2}
                                                                    key={"sen_"+passage["id"].toString()}
                                                                    idx={passage["id"]}
                                                                    search_term={search_term}
                                                                    search_term_language={this.state.selected_language}
                                             />
                                    })}
                                </div>
                            </div>}

                        </div>
                    </div>
                }
                <div id="tooltip_main_barchart">

                </div>
            </div>
        )
    }

}

export default Main;